import {
	Input,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@dune/ui";
import { formatCurrency } from "@dune/utils";
import { useMemo } from "react";
import { useFormContext } from "react-hook-form";

const GFAFinancingsSummaryContainer = () => {
	const { watch } = useFormContext();

	const watchedValues = watch([
		"estimatedSalePriceHT",
		"estimatedSalePriceTTC",
		"costPriceHT",
		"costPriceTTC",
	]);

	const calculateResidualTVA = useMemo(() => {
		const [
			estimatedSalePriceHT,
			estimatedSalePriceTTC,
			costPriceHT,
			costPriceTTC,
		] = watchedValues;

		if (
			!estimatedSalePriceTTC ||
			!estimatedSalePriceHT ||
			!costPriceTTC ||
			!costPriceHT
		) {
			return null;
		}

		const estimatedSalePriceResidualTVA =
			estimatedSalePriceTTC - estimatedSalePriceHT;
		const costPriceResidualTVA = costPriceTTC - costPriceHT;

		return estimatedSalePriceResidualTVA - costPriceResidualTVA;
	}, [watchedValues[0], watchedValues[1], watchedValues[2], watchedValues[3]]);

	const calculateProjectedMarginHT = useMemo(() => {
		const [estimatedSalePriceHT, , costPriceHT] = watchedValues;

		if (!estimatedSalePriceHT || !costPriceHT) {
			return null;
		}

		return estimatedSalePriceHT - costPriceHT;
	}, [watchedValues[0], watchedValues[2]]);

	const calculateProjectedMarginRatio = useMemo(() => {
		const [estimatedSalePriceHT, , costPriceHT] = watchedValues;

		if (!estimatedSalePriceHT || !costPriceHT) {
			return null;
		}
		return (estimatedSalePriceHT - costPriceHT) / costPriceHT;
	}, [watchedValues[0], watchedValues[2]]);

	return (
		<div className="w-full rounded-lg border bg-gray-100">
			<Table>
				<TableHeader>
					<TableRow>
						<TableHead className="p-4 w-1/2 font-semibold text-gray-900">
							TVA Résiduelle
						</TableHead>
						<TableHead className="font-semibold text-gray-900">
							Marge Prévisionnelle
						</TableHead>
						<TableHead className="font-semibold text-gray-900" />
					</TableRow>
				</TableHeader>
				<TableBody>
					<TableRow>
						<TableCell className="p-4 font-medium">
							<Input
								className="border-0 shadow-none bg-transparent h-auto p-0 focus-visible:ring-0 focus-visible:border-0"
								value={
									calculateResidualTVA !== null
										? formatCurrency(Number(calculateResidualTVA))
										: "-"
								}
								disabled
							/>
						</TableCell>
						<TableCell className="p-4 font-medium">
							<Input
								className="border-0 shadow-none bg-transparent h-auto p-0 focus-visible:ring-0 focus-visible:border-0"
								value={
									calculateProjectedMarginHT !== null
										? formatCurrency(Number(calculateProjectedMarginHT))
										: "-"
								}
								disabled
							/>
						</TableCell>
						<TableCell className="p-4 font-medium">
							<Input
								className="border-0 shadow-none bg-transparent h-auto p-0 focus-visible:ring-0 focus-visible:border-0"
								value={
									calculateProjectedMarginRatio !== null
										? `${(Number(calculateProjectedMarginRatio) * 100).toFixed(2)} %`
										: "-"
								}
								disabled
							/>
						</TableCell>
					</TableRow>
				</TableBody>
			</Table>
		</div>
	);
};

export default GFAFinancingsSummaryContainer;
